export const UPDATE_SETTINGS_SUCCESS = 'UPDATE_SETTINGS_SUCCESS';
export const UPDATE_SETTINGS_FAILED = 'UPDATE_SETTINGS_FAILED';

export const UPDATE_SETTINGS_PASSWORD_SUCCESS = 'UPDATE_SETTINGS_PASSWORD_SUCCESS';
export const UPDATE_SETTINGS_PASSWORD_FAILED = 'UPDATE_SETTINGS_PASSWORD_FAILED';
